(function(){
if(window.__szx)return;window.__szx=1;
function money(c){return (c/100).toLocaleString('pl-PL',{minimumFractionDigits:2,maximumFractionDigits:2})+' zł'}
function ready(f){document.readyState!=='loading'?f():document.addEventListener('DOMContentLoaded',f)}
ready(function(){
 // countdown
 document.querySelectorAll('[data-sz-countdown]').forEach(function(el){
  var end=new Date(el.getAttribute('data-sz-countdown')).getTime();if(isNaN(end)){el.remove();return}
  function p(n){return (n<10?'0':'')+n}
  function tick(){var d=end-Date.now();if(d<=0){el.remove();clearInterval(t);return}
   el.querySelector('[data-d]').textContent=p(Math.floor(d/864e5));el.querySelector('[data-h]').textContent=p(Math.floor(d/36e5)%24);
   el.querySelector('[data-m]').textContent=p(Math.floor(d/6e4)%60);el.querySelector('[data-s]').textContent=p(Math.floor(d/1e3)%60)}
  var t=setInterval(tick,1000);tick();
 });
 // gallery
 document.querySelectorAll('.sz-gal').forEach(function(g){var img=g.querySelector('.sz-mainimg');
  g.querySelectorAll('.sz-thumbs button').forEach(function(b){b.addEventListener('click',function(){
   g.querySelectorAll('.sz-thumbs button').forEach(function(x){x.classList.remove('on')});b.classList.add('on');
   if(img){img.removeAttribute('srcset');img.style.opacity=.3;img.src=b.dataset.src;img.onload=function(){img.style.opacity=1}}})})});
 var pdp=document.querySelector('[data-sz-pdp]');
 var state={qty:1,total:0,name:''};
 function sync(){if(!pdp)return;
  var r=pdp.querySelector('input[name=sz_tier]:checked')||pdp.querySelector('input[name=sz_tier]');if(!r)return;
  pdp.querySelectorAll('.sz-tier').forEach(function(l){l.classList.toggle('on',l.contains(r))});
  var qty=+r.value,tot=+r.dataset.total,save=+r.dataset.save,pct=+r.dataset.pct;
  var add=pdp.querySelector('[data-sz-addon]'),addc=add&&add.checked?+add.dataset.price:0;
  var q=function(s){return pdp.querySelector(s)};
  q('[data-sz-qty]').value=qty;
  q('[data-sz-sname]').textContent=r.dataset.name;
  q('[data-sz-sprod]').textContent=money(tot);
  q('[data-sz-spct]').textContent=pct>0&&qty>1?'(−'+pct+'%)':'';
  var ar=q('[data-sz-saddrow]');if(ar){ar.style.display=addc?'':'none';q('[data-sz-sadd]').textContent=money(addc)}
  q('[data-sz-stot]').textContent=money(tot+addc);
  q('[data-sz-saveline]').textContent=save>0?'🎉 Oszczędzasz '+money(save)+' względem zakupu pojedynczo':'';
  state={qty:qty,total:tot+addc,name:r.dataset.name};
  document.querySelectorAll('[data-sz-stname]').forEach(function(e){e.textContent=state.name});
  document.querySelectorAll('[data-sz-sttot]').forEach(function(e){e.textContent=money(state.total)});
  document.querySelectorAll('[data-sz-ctasel]').forEach(function(e){e.textContent='Wybrany zestaw: '+state.name+' · '+money(state.total)});
 }
 if(pdp){
  if(!pdp.querySelector('input[name=sz_tier]:checked')){var f0=pdp.querySelector('input[name=sz_tier]');if(f0)f0.checked=true}
  pdp.querySelectorAll('input[name=sz_tier],[data-sz-addon]').forEach(function(i){i.addEventListener('change',sync)});
  var m=location.search.match(/[?&]qty=(\d)/);if(m){var rr=pdp.querySelector('input[name=sz_tier][value="'+m[1]+'"]');if(rr)rr.checked=true}
  sync();
  var form=document.getElementById('sz-form');
  form.addEventListener('submit',function(e){e.preventDefault();
   var btn=form.querySelector('[data-sz-atc]');btn.disabled=true;
   var items=[{id:+form.querySelector('[data-sz-variant]').value,quantity:state.qty}];
   var add=pdp.querySelector('[data-sz-addon]');if(add&&add.checked)items.push({id:+add.dataset.szAddon,quantity:1});
   var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
   fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
    .then(function(r){if(!r.ok)throw 0;location.href=root+'cart'})
    .catch(function(){btn.disabled=false;form.submit()});
  });
 }
 function buy(){if(pdp){var f=document.getElementById('sz-form');if(f.requestSubmit)f.requestSubmit();else f.dispatchEvent(new Event('submit',{cancelable:true}))}else location.href='/#sz-buy'}
 document.querySelectorAll('[data-sz-pick]').forEach(function(a){a.addEventListener('click',function(e){
  if(!pdp)return;e.preventDefault();var r=pdp.querySelector('input[name=sz_tier][value="'+a.dataset.szPick+'"]');if(r){r.checked=true;sync()}
  document.getElementById('sz-buy').scrollIntoView({behavior:'smooth',block:'start'})})});
 document.querySelectorAll('[data-sz-buynow]').forEach(function(b){b.addEventListener('click',function(e){if(!pdp)return;e.preventDefault();buy()})});
 // sticky
 var st=document.querySelector('[data-sz-sticky]'),atc=document.querySelector('[data-sz-atc]');
 if(st&&atc&&'IntersectionObserver' in window){new IntersectionObserver(function(en){st.classList.toggle('show',!en[0].isIntersecting&&en[0].boundingClientRect.top<0)}).observe(atc)}
 // cart
 var cf=document.getElementById('sz-cart-form');
 if(cf){cf.querySelectorAll('[data-sz-step]').forEach(function(b){b.addEventListener('click',function(){var i=b.parentNode.querySelector('input');i.value=Math.max(0,(+i.value||0)+(+b.dataset.szStep));cf.submit()})});
  cf.querySelectorAll('.sz-qty input').forEach(function(i){i.addEventListener('change',function(){cf.submit()})});
  cf.querySelectorAll('[data-sz-upgrade]').forEach(function(b){b.addEventListener('click',function(){var box=b.closest('.sz-upsell'),root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';b.disabled=true;
   fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:+box.dataset.line,quantity:+box.dataset.qty})}).then(function(){location.reload()},function(){location.reload()})})})}
});
})();
